export default __webpack_public_path__ + "static/media/service-thumb-concrete-walls.6ec5339e.jpg";